import { useEffect, useRef } from 'react';
import { addPagePropertiesFromRenderContext } from '@/utils/dataLayer';
import type { UserDataResponse } from '@/hooks/useUserData/useUserData';
import type { WebappResponse } from '@eventbrite/event-listing-service-client';

type UsePagePropertiesTrackingEffectArgs = {
  pageContext: WebappResponse | null | undefined;
  userData: UserDataResponse | null | undefined;
};

export function usePagePropertiesTrackingEffect({ pageContext, userData }: UsePagePropertiesTrackingEffectArgs) {
  const pagePropertiesTrackedEventIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!pageContext?.basicInfo?.id || userData === undefined) {
      return;
    }

    if (pagePropertiesTrackedEventIdRef.current === pageContext.basicInfo.id) {
      return;
    }

    pagePropertiesTrackedEventIdRef.current = pageContext.basicInfo.id;
    addPagePropertiesFromRenderContext(pageContext, !!userData?.userId);
  }, [pageContext, userData]);
}
